import React, { useState } from "react";

const TermsConditions = () => {
  const [activeSection, setActiveSection] = useState("01");

  const sections = [
    {
      id: "01",
      title: "Acceptance of Terms",
      content: (
        <p>
          By accessing or using <strong>School Hub</strong> ("we," "our,"
          "us"), you agree to be bound by these Terms and Conditions. If you
          do not agree with any part of these terms, you must not use our
          website or services.
        </p>
      ),
    },
    {
      id: "02",
      title: "Eligibility",
      content: (
        <>
          <p>To use our services, you must:</p>
          <ul>
            <li>Be at least 13 years of age</li>
            <li>Provide accurate and complete registration information</li>
            <li>Maintain the security of your account credentials</li>
            <li>
              Comply with all applicable local, state, and national laws
            </li>
          </ul>
        </>
      ),
    },
    {
      id: "03",
      title: "User Account Responsibilities",
      content: (
        <>
          <p>
            When you create an account with us, you are responsible for:
          </p>
          <ul>
            <li>Keeping your password confidential and secure</li>
            <li>All activities that occur under your account</li>
            <li>Notifying us immediately of any unauthorized use</li>
            <li>Not sharing your account with others</li>
          </ul>
        </>
      ),
    },
    {
      id: "04",
      title: "Course Enrollment & Payments",
      content: (
        <>
          <p>By enrolling in any course, you agree to the following:</p>
          <ul>
            <li>
              All fees must be paid in full before course access is granted
            </li>
            <li>Prices are subject to change without prior notice</li>
            <li>
              Refunds are only available within 7 days of purchase, subject
              to our refund policy
            </li>
            <li>Course content is licensed for personal use only</li>
          </ul>
        </>
      ),
    },
    {
      id: "05",
      title: "Intellectual Property Rights",
      content: (
        <p>
          All content on this platform — including videos, text, graphics,
          logos, and course materials — is the property of School Hub and is
          protected by copyright and intellectual property laws. You may not
          copy, reproduce, distribute, or create derivative works without our
          express written permission.
        </p>
      ),
    },
    {
      id: "06",
      title: "Prohibited Activities",
      content: (
        <>
          <p>You agree NOT to:</p>
          <ul>
            <li>Share, resell, or redistribute course content</li>
            <li>Use the platform for any illegal or unauthorized purpose</li>
            <li>Attempt to hack, disrupt, or damage our services</li>
            <li>Post abusive, harmful, or misleading content</li>
            <li>Impersonate another user or our staff</li>
          </ul>
        </>
      ),
    },
    {
      id: "07",
      title: "Refund & Cancellation Policy",
      content: (
        <>
          <p>
            We offer a 7-day refund window for most courses. To request a
            refund:
          </p>
          <ul>
            <li>Contact support within 7 days of purchase</li>
            <li>Provide your order ID and reason for refund</li>
            <li>Refunds are processed within 7–10 business days</li>
            <li>
              Courses with more than 30% completion are not eligible for
              refunds
            </li>
          </ul>
        </>
      ),
    },
    {
      id: "08",
      title: "Third-Party Links",
      content: (
        <p>
          Our website may contain links to third-party websites or services.
          We are not responsible for the content, privacy policies, or
          practices of any third-party sites. You access them at your own
          risk.
        </p>
      ),
    },
    {
      id: "09",
      title: "Disclaimer of Warranties",
      content: (
        <p>
          Our services are provided "as is" and "as available" without
          warranties of any kind, either express or implied. We do not
          guarantee that the platform will be uninterrupted, error-free, or
          free of viruses. Your use of the service is at your sole risk.
        </p>
      ),
    },
    {
      id: "10",
      title: "Limitation of Liability",
      content: (
        <p>
          To the maximum extent permitted by law, School Hub shall not be
          liable for any indirect, incidental, special, or consequential
          damages arising from your use of our services, including but not
          limited to loss of data, revenue, or profits.
        </p>
      ),
    },
    {
      id: "11",
      title: "Termination",
      content: (
        <p>
          We reserve the right to suspend or terminate your account at any
          time, without prior notice, if you violate these Terms. Upon
          termination, your right to access our services will immediately
          cease.
        </p>
      ),
    },
    {
      id: "12",
      title: "Governing Law",
      content: (
        <p>
          These Terms shall be governed by and construed in accordance with
          the laws of India. Any disputes arising shall be subject to the
          exclusive jurisdiction of the courts of India.
        </p>
      ),
    },
    {
      id: "13",
      title: "Changes to Terms",
      content: (
        <p>
          We may update these Terms and Conditions from time to time.
          Continued use of our services after changes are posted constitutes
          your acceptance of the revised Terms.
        </p>
      ),
    },
  ];

  const scrollToSection = (id) => {
    setActiveSection(id);

    const element = document.getElementById(`terms-${id}`);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="terms-page">
      <style>{`
        * {
          box-sizing: border-box;
        }

        html {
          scroll-behavior: smooth;
        }

        body {
          margin: 0;
        }

        .terms-page {
          min-height: 100vh;
          font-family:
            Inter,
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            sans-serif;
          color: #172033;
          background:
            radial-gradient(
              circle at 90% 0%,
              rgba(99,102,241,.13),
              transparent 28%
            ),
            radial-gradient(
              circle at 0% 35%,
              rgba(124,58,237,.08),
              transparent 25%
            ),
            #f7f8fc;
        }

        /* ================= HEADER ================= */

        .terms-header {
          position: sticky;
          top: 0;
          z-index: 100;
          height: 76px;
          background: rgba(255,255,255,.88);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(226,232,240,.8);
        }

        .header-inner {
          max-width: 1240px;
          height: 100%;
          margin: auto;
          padding: 0 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .brand {
          display: flex;
          align-items: center;
          gap: 11px;
          text-decoration: none;
        }

        .brand-mark {
          width: 38px;
          height: 38px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 17px;
          font-weight: 900;
          background:
            linear-gradient(
              135deg,
              #111827,
              #312e81,
              #4f46e5
            );
          box-shadow:
            0 8px 20px rgba(79,70,229,.25);
        }

        .brand-name {
          font-size: 19px;
          font-weight: 900;
          letter-spacing: -.6px;
          color: #111827;
        }

        .brand-name span {
          color: #6366f1;
        }

        .nav {
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .nav a {
          text-decoration: none;
          color: #64748b;
          font-size: 13px;
          font-weight: 700;
          padding: 9px 13px;
          border-radius: 9px;
          transition: .2s;
        }

        .nav a:hover {
          color: #4f46e5;
          background: #eef2ff;
        }

        .nav .nav-button {
          color: white;
          margin-left: 5px;
          padding: 10px 16px;
          background: #111827;
          box-shadow: 0 6px 15px rgba(15,23,42,.14);
        }

        .nav .nav-button:hover {
          color: white;
          background: #312e81;
        }

        /* ================= HERO ================= */

        .hero {
          max-width: 1240px;
          margin: auto;
          padding: 76px 24px 62px;
          text-align: center;
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 7px 13px;
          border-radius: 999px;
          background: rgba(255,255,255,.8);
          border: 1px solid #e5e7eb;
          box-shadow: 0 5px 18px rgba(15,23,42,.05);
          color: #4f46e5;
          font-size: 11px;
          font-weight: 900;
          letter-spacing: 1.3px;
        }

        .badge-dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #6366f1;
          box-shadow: 0 0 0 5px rgba(99,102,241,.10);
        }

        .hero h1 {
          margin: 20px auto 0;
          max-width: 900px;
          font-size: clamp(42px, 6vw, 70px);
          line-height: 1;
          letter-spacing: -4px;
          font-weight: 950;
          color: #111827;
        }

        .hero h1 span {
          background:
            linear-gradient(
              90deg,
              #312e81,
              #4f46e5,
              #7c3aed
            );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .hero p {
          max-width: 680px;
          margin: 22px auto 0;
          color: #64748b;
          font-size: 16px;
          line-height: 1.8;
        }

        .hero-meta {
          margin-top: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 9px;
          color: #94a3b8;
          font-size: 12px;
          font-weight: 700;
        }

        .meta-dot {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #cbd5e1;
        }

        /* ================= MAIN ================= */

        .main {
          max-width: 1180px;
          margin: auto;
          padding: 0 24px 90px;
        }

        .terms-shell {
          display: grid;
          grid-template-columns: 245px minmax(0,1fr);
          gap: 28px;
          align-items: start;
        }

        /* ================= SIDEBAR ================= */

        .sidebar {
          position: sticky;
          top: 98px;
          background: rgba(255,255,255,.88);
          border: 1px solid #e5e7eb;
          border-radius: 20px;
          padding: 15px;
          box-shadow:
            0 15px 45px rgba(15,23,42,.055);
        }

        .sidebar-label {
          padding: 7px 10px 12px;
          color: #94a3b8;
          font-size: 10px;
          font-weight: 900;
          letter-spacing: 1.4px;
        }

        .side-item {
          width: 100%;
          border: 0;
          background: transparent;
          display: flex;
          align-items: center;
          gap: 10px;
          text-align: left;
          padding: 10px;
          margin-bottom: 3px;
          border-radius: 10px;
          color: #64748b;
          cursor: pointer;
          font-size: 12px;
          font-weight: 700;
          transition: .2s;
        }

        .side-item:hover {
          background: #f8fafc;
          color: #4f46e5;
        }

        .side-item.active {
          background: #eef2ff;
          color: #4f46e5;
        }

        .side-number {
          font-size: 10px;
          font-weight: 900;
          opacity: .7;
          min-width: 20px;
        }

        /* ================= DOCUMENT ================= */

        .document {
          background: rgba(255,255,255,.95);
          border: 1px solid #e5e7eb;
          border-radius: 28px;
          overflow: hidden;
          box-shadow:
            0 30px 80px rgba(15,23,42,.075),
            0 5px 20px rgba(15,23,42,.025);
        }

        .document-top {
          padding: 25px 34px;
          border-bottom: 1px solid #edf0f4;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .document-label {
          color: #111827;
          font-size: 13px;
          font-weight: 850;
        }

        .document-status {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          padding: 7px 11px;
          border-radius: 999px;
          background: #f0fdf4;
          border: 1px solid #dcfce7;
          color: #15803d;
          font-size: 10px;
          font-weight: 850;
        }

        .status-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #22c55e;
        }

        /* ================= INTRO ================= */

        .document-intro {
          margin: 26px 34px 8px;
          padding: 27px;
          border-radius: 18px;
          background:
            linear-gradient(
              135deg,
              #0f172a 0%,
              #1e1b4b 55%,
              #312e81 100%
            );
          color: white;
          position: relative;
          overflow: hidden;
        }

        .document-intro::after {
          content: "";
          position: absolute;
          width: 240px;
          height: 240px;
          right: -100px;
          top: -130px;
          border-radius: 50%;
          background: rgba(129,140,248,.25);
        }

        .intro-small {
          position: relative;
          z-index: 2;
          color: #a5b4fc;
          font-size: 10px;
          font-weight: 900;
          letter-spacing: 1.4px;
          margin-bottom: 9px;
        }

        .intro-title {
          position: relative;
          z-index: 2;
          font-size: 20px;
          font-weight: 850;
          margin-bottom: 8px;
        }

        .intro-text {
          position: relative;
          z-index: 2;
          max-width: 700px;
          color: #cbd5e1;
          font-size: 13px;
          line-height: 1.8;
          margin: 0;
        }

        /* ================= WARNING ================= */

        .notice {
          margin: 20px 34px 8px;
          padding: 17px 18px;
          display: flex;
          align-items: center;
          gap: 13px;
          border-radius: 14px;
          background: #fffbeb;
          border: 1px solid #fde68a;
        }

        .notice-icon {
          width: 35px;
          height: 35px;
          min-width: 35px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fef3c7;
          color: #b45309;
          font-size: 15px;
          font-weight: 900;
        }

        .notice-title {
          margin: 0 0 3px;
          color: #92400e;
          font-size: 12px;
          font-weight: 850;
        }

        .notice-text {
          margin: 0;
          color: #a16207;
          font-size: 11px;
          line-height: 1.6;
        }

        /* ================= SECTIONS ================= */

        .sections {
          padding: 12px 34px 34px;
        }

        .terms-section {
          scroll-margin-top: 95px;
          padding: 31px 0;
          border-bottom: 1px solid #edf0f4;
        }

        .section-heading {
          display: flex;
          align-items: center;
          gap: 14px;
          margin-bottom: 16px;
        }

        .section-number {
          width: 42px;
          height: 42px;
          min-width: 42px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          color: #4f46e5;
          background: #eef2ff;
          border: 1px solid #e0e7ff;
          font-size: 10px;
          font-weight: 900;
        }

        .section-title {
          margin: 0;
          color: #111827;
          font-size: 19px;
          letter-spacing: -.3px;
          font-weight: 850;
        }

        .section-content {
          margin-left: 56px;
        }

        .section-content p {
          margin: 0 0 14px;
          color: #64748b;
          font-size: 14px;
          line-height: 1.9;
        }

        .section-content strong {
          color: #4f46e5;
        }

        .section-content ul {
          margin: 14px 0 0;
          padding: 0;
          list-style: none;
          display: grid;
          gap: 8px;
        }

        .section-content li {
          position: relative;
          padding: 12px 14px 12px 38px;
          border: 1px solid #edf0f4;
          border-radius: 11px;
          background: #fafbfc;
          color: #475569;
          font-size: 13px;
          line-height: 1.6;
        }

        .section-content li::before {
          content: "✓";
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: #eef2ff;
          color: #4f46e5;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 9px;
          font-weight: 900;
        }

        /* ================= SECURITY ================= */

        .security-card {
          margin: 10px 34px 34px;
          padding: 22px;
          display: flex;
          align-items: center;
          gap: 15px;
          border-radius: 17px;
          background: #f8fafc;
          border: 1px solid #e5e7eb;
        }

        .security-icon {
          width: 42px;
          height: 42px;
          min-width: 42px;
          border-radius: 13px;
          background: #111827;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 17px;
        }

        .security-title {
          margin: 0 0 4px;
          color: #111827;
          font-size: 13px;
          font-weight: 850;
        }

        .security-text {
          margin: 0;
          color: #64748b;
          font-size: 12px;
          line-height: 1.6;
        }

        /* ================= CONTACT ================= */

        .contact {
          margin: 0 34px 34px;
          padding: 28px;
          border-radius: 21px;
          background:
            linear-gradient(
              135deg,
              #eef2ff,
              #f5f3ff
            );
          border: 1px solid #e0e7ff;
        }

        .contact-label {
          color: #6366f1;
          font-size: 10px;
          font-weight: 900;
          letter-spacing: 1.4px;
        }

        .contact h2 {
          margin: 7px 0;
          color: #111827;
          font-size: 22px;
          font-weight: 900;
          letter-spacing: -.5px;
        }

        .contact p {
          margin: 0 0 18px;
          color: #64748b;
          font-size: 13px;
          line-height: 1.7;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10px;
        }

        .contact-item {
          padding: 14px;
          background: rgba(255,255,255,.75);
          border: 1px solid rgba(255,255,255,.9);
          border-radius: 12px;
        }

        .contact-item small {
          display: block;
          margin-bottom: 5px;
          color: #94a3b8;
          font-size: 9px;
          font-weight: 900;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        .contact-item strong {
          color: #334155;
          font-size: 12px;
          word-break: break-word;
        }

        /* ================= FOOTER ================= */

        .footer {
          padding: 32px 20px;
          background: #080d18;
          text-align: center;
          color: #64748b;
          font-size: 12px;
        }

        .footer strong {
          color: white;
        }

        /* ================= RESPONSIVE ================= */

        @media(max-width: 900px) {
          .terms-shell {
            grid-template-columns: 1fr;
          }

          .sidebar {
            position: static;
            display: flex;
            overflow-x: auto;
            gap: 4px;
            padding: 10px;
          }

          .sidebar-label {
            display: none;
          }

          .side-item {
            min-width: max-content;
            margin: 0;
          }
        }

        @media(max-width: 650px) {
          .terms-header {
            height: auto;
          }

          .header-inner {
            padding: 13px 16px;
            flex-direction: column;
            gap: 10px;
          }

          .nav a {
            font-size: 11px;
            padding: 8px 9px;
          }

          .nav .nav-button {
            margin-left: 0;
          }

          .hero {
            padding: 105px 18px 40px;
          }

          .hero h1 {
            font-size: 43px;
            letter-spacing: -2.5px;
          }

          .hero p {
            font-size: 14px;
          }

          .main {
            padding: 0 12px 55px;
          }

          .document {
            border-radius: 20px;
          }

          .document-top {
            padding: 19px;
          }

          .document-intro {
            margin: 18px 18px 5px;
            padding: 21px;
          }

          .notice {
            margin: 18px 18px 5px;
          }

          .sections {
            padding: 5px 19px 20px;
          }

          .terms-section {
            padding: 25px 0;
          }

          .section-title {
            font-size: 17px;
          }

          .section-content {
            margin-left: 0;
          }

          .section-content p,
          .section-content li {
            font-size: 13px;
          }

          .security-card {
            margin: 8px 19px 20px;
            padding: 17px;
          }

          .contact {
            margin: 0 19px 20px;
            padding: 21px;
          }

          .contact-grid {
            grid-template-columns: 1fr;
          }
        }

        @media(max-width: 400px) {
          .brand-name {
            font-size: 16px;
          }

          .brand-mark {
            width: 34px;
            height: 34px;
          }

          .hero h1 {
            font-size: 37px;
          }

          .section-number {
            width: 38px;
            height: 38px;
            min-width: 38px;
          }
        }
      `}</style>

      {/* HEADER */}
  

      {/* HERO */}
      <section className="hero">
        <div className="hero-badge">
          <span className="badge-dot" />
          TERMS & CONDITIONS
        </div>

        <h1>
          Clear terms.
          {/* <br /> */}
          {/* <span>Better experience.</span> */}
        </h1>

        <p>
          Please review the terms that govern your use of School Hub,
          our courses, platform, and educational services.
        </p>

        <div className="hero-meta">
          <span>Last Updated January 2025</span>

          <span className="meta-dot" />

          <span>13 Terms & Conditions</span>
        </div>
      </section>

      {/* MAIN */}
      <main className="main">
        <div className="terms-shell">

          {/* SIDEBAR */}
          <aside className="sidebar">
            <div className="sidebar-label">
              ON THIS PAGE
            </div>

            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className={`side-item ${
                  activeSection === section.id ? "active" : ""
                }`}
              >
                <span className="side-number">
                  {section.id}
                </span>

                <span>{section.title}</span>
              </button>
            ))}

            <button
              onClick={() => scrollToSection("14")}
              className={`side-item ${
                activeSection === "14" ? "active" : ""
              }`}
            >
              <span className="side-number">
                14
              </span>

              <span>Contact Us</span>
            </button>
          </aside>

          {/* DOCUMENT */}
          <article className="document">

            <div className="document-top">
              <div className="document-label">
                Terms & Conditions
              </div>

              <div className="document-status">
                <span className="status-dot" />
                Active Terms
              </div>
            </div>

            {/* INTRO */}
            <div className="document-intro">
              <div className="intro-small">
                School Hub • LEGAL
              </div>

              <div className="intro-title">
                Welcome to School Hub.
              </div>

              <p className="intro-text">
                These Terms and Conditions govern your access to and
                use of our website, courses, and educational services.
                Please read them carefully before using our platform.
              </p>
            </div>

            {/* WARNING */}
            <div className="notice">
              <div className="notice-icon">
                !
              </div>

              <div>
                <h3 className="notice-title">
                  Important Notice
                </h3>

                <p className="notice-text">
                  By using our services, you acknowledge that you have
                  read, understood, and agreed to be bound by these Terms.
                </p>
              </div>
            </div>

            {/* SECTIONS */}
            <div className="sections">
              {sections.map((section) => (
                <section
                  key={section.id}
                  id={`terms-${section.id}`}
                  className="terms-section"
                  onMouseEnter={() =>
                    setActiveSection(section.id)
                  }
                >
                  <div className="section-heading">
                    <div className="section-number">
                      {section.id}
                    </div>

                    <h2 className="section-title">
                      {section.title}
                    </h2>
                  </div>

                  <div className="section-content">
                    {section.content}
                  </div>
                </section>
              ))}
            </div>

            {/* SECURITY */}
            <div className="security-card">
              <div className="security-icon">
                ◇
              </div>

              <div>
                <h3 className="security-title">
                  Use our platform responsibly
                </h3>

                <p className="security-text">
                  Please protect your account credentials and respect
                  our educational content and community guidelines.
                </p>
              </div>
            </div>

            {/* CONTACT */}
            <section
              id="terms-14"
              className="contact"
              onMouseEnter={() =>
                setActiveSection("14")
              }
            >
              <div className="contact-label">
                NEED ASSISTANCE?
              </div>

              <h2>Contact our support team</h2>

              <p>
                If you have any questions about these Terms and
                Conditions, please reach out to us.
              </p>

              <div className="contact-grid">
                <div className="contact-item">
                  <small>Email</small>
                  <strong>
                    support@jomedtuon.com
                  </strong>
                </div>

                <div className="contact-item">
                  <small>Website</small>
                  <strong>
                    www.jomedtuon.com
                  </strong>
                </div>

                <div className="contact-item">
                  <small>Location</small>
                  <strong>India</strong>
                </div>
              </div>
            </section>
          </article>
        </div>
      </main>

      {/* FOOTER */}
  
    </div>
  );
};

export default TermsConditions;